<!--  -->
<template>
    <div class="wrapper box box_v">
    <!-- 头部标题 -->
    <div class="header-wrapper box">
      <div class="left">
        <div class="iconfont icon-fanhui2" style="font-size:35px" @click="goback"></div>
      </div>
      <div class="header">积分设置</div>
      <div class="newvote">
        <Button class="btn-dc" type="primary" @click="save" :loading="isSave">保存</Button>
      </div>
    </div>
    <div class="content box_f1">
      <Card style="height:100%;padding:14px 4px">

        <div class="box item" v-for="(item, index) in inputList" :key="index">
            <div v-if="item.scoreType!='sign_in'" class="box">
                <div class="jftitle">{{item.title}}</div>
                <Input
                    :placeholder="item.title ? item.title : '请输入'"
                    :disabled="item.noEditable"
                    v-model="item.score"
                    class="box_f1"
                    style="width: 360px;"
                />
                <div class="suffix">分</div>
            </div>
            <div v-else class="box">
                <div  class="jftitle">活动签到</div>
                <div  style="width:80px">活动积分 *</div>
                <Input
                    :placeholder="item.title ? item.title : '请输入'"
                    :disabled="item.noEditable"
                    v-model="item.score"
                    class="box_f1"
                    style="width: 280px;"
                />
                <div  class="suffix">%</div>
            </div>


            <div v-if="item.limitUpper" class="box">
                <div class="limittitle">日上限</div>
                <Input
                    :placeholder="item.title ? item.title : '请输入'"
                    :disabled="item.noEditable"
                    v-model="item.limitUpper"
                    class="box_f1"
                    style="width: 360px;"
                />
                <div class="suffix">次</div>
            </div>

            <span class="notice">{{item.notice}}</span>
        
        </div>
        <div class="box item">
            <div  class="box">
                <div class="jftitle">积分翻倍</div>
            </div>
            <Select v-model="selectList" multiple style="width:360px">
                <Option v-for="item in jfDoubleList" :value="item.scoreType" :key="item.scoreType">{{ item.title }}</Option>
            </Select>
            <span class="notice" style="margin-left:20px">说明：实名认证后此项积分翻倍</span>    
        </div>
        
        <Spin fix v-if="spinShow"></Spin>
      </Card>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            apptype:this.$route.query.apptype,
            spinShow:true,
            inputList:[],
            jfDoubleList:[],//积分翻倍选项
            selectList:[],//积分翻倍的list
            isSave:false,
            filterarr:['evaluate','event_execute','rubbish_game']
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        //返回
        goback(){
            this.$router.push({ name: "miniProgram", query: { state: 1 } });
        },
        //获取积分
        getJf(){
            var url = this.urlobj.getJfRule(this.apptype);
            this.$get(url, {}).then(res => {
                if (res.isSucceed) {
                    this.spinShow = false;
                    this.inputList = res.rows.map(item=>{
                        return {
                            scoreType:item.scoreType,
                            title:this.getTitle(item.scoreType,item.remark),
                            score:item.scoreType=='sign_in'?res.newPrimaryKeys.signPercent:(item.score/100),
                            limitUpper:item.scoreType=='realname'?0:item.limitUpper,
                            notice:this.getNotice(item.scoreType),
                            scoreMultiple:item.scoreMultiple,
                            remark:item.remark,
                        }
                    }).filter(item=>this.filterarr.indexOf(item.scoreType) == -1)
                    this.jfDoubleList = this.inputList.filter(item=>item.scoreType!='realname')
                    this.selectList = this.inputList.filter(item=>item.scoreMultiple==2).map(item=>item.scoreType)
                } else {
                    this.$Message.warning(res.message);
                    this.spinShow = false;
                }
            }).catch(e=>{
                this.$Message.warning(e);
                this.spinShow = false;
            })
        },
        //重置部分标题
        getTitle(type,title){
            let _title = ''
            switch(type){
                case 'send_friends':
                    _title = this.apptype=='mst'?'邻里圈发布':'先锋圈发布';
                    break;
                case 'friends_comment':
                    _title = this.apptype=='mst'?'邻里圈评论':'先锋圈评论';
                    break;
                default:
                    _title = title;
                    break;
            }
            return _title
        },
        //加备注
        getNotice(type){
            let notice = ''
            switch(type){
                case 'event_report':
                    notice = '说明：事件上报，社区受理后可获得积分';
                    break;
                case 'event_evaluate':
                    notice = '说明：事件办结后评价事件可获得积分';
                    break;
                case 'activity_comment':
                    notice = '说明：评论活动可获得积分';
                    break;
                case 'realname':
                    notice = '说明：实名认证审核通过后可获得积分';
                    break;
                case 'send_friends':
                    notice = '说明：'+(this.apptype=='mst'?'邻里圈':'先锋圈')+'发布动态可获得积分';
                    break;
                case 'friends_comment':
                    notice = '说明：'+(this.apptype=='mst'?'邻里圈':'先锋圈')+'评论动态可获得积分';
                    break;
                default:
                    break;
            }
            return notice
        },
        //保存积分
        save(){
            this.spinShow = true;
            this.isSave = true
            let percent = 100
            let scoreRuleList = this.inputList.map(item=>{
                item.scoreType=='sign_in' && (percent=item.score) 
                return {
                    score:item.score*100,
                    scoreType:item.scoreType,
                    scoreUpper:0,
                    limitUpper:item.scoreType=='realname'?1:parseInt(item.limitUpper),
                    scoreMultiple:this.selectList.indexOf(item.scoreType)>-1?2:1,
                    remark:item.remark
                }
            })
            
            var setJf = this.setJf(scoreRuleList)
            var setAuthJf =  this.setAuthJf(percent)
            Promise.all([setJf,setAuthJf]).then(res => {
                console.log(res)
                this.spinShow=false
                this.isSave=false
                res.forEach(item => {
                    if (!item.isSucceed) {
                        this.$Message.error('保存失败')
                        return
                    }
                })
                this.$Message.success('保存成功')
            })
        },
        setJf(val){
            return new Promise((resolve, reject) => {
                var url = this.urlobj.getJfRule(this.apptype);
                this.$post(url, val).then(res => {
                     resolve(res);
                }).catch(e=>{
                    reject(e);
                
                })
            })
        },
        setAuthJf(val){
            return new Promise((resolve, reject) => {
                var url = this.urlobj.setAuthJf;
                let data = {}
                if(this.apptype=='mst'){
                    data = {
                        percentResident:val
                    }
                }else{
                    data = {
                        percent:val
                    }
                }
                this.$post(url,data).then(res => {
                     resolve(res);
                }).catch(e=>{
                    reject(e);
                    
                })
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        if(this.$route.query.apptype=='xfej') this.filterarr =this.filterarr.concat(['vote','invite_friends'])
        this.getJf()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
  min-width: 1366px;
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}
.newvote {
  position: absolute;
  right: 20px;
  button {
    height: 28px;
    line-height: 13px;
  }
  .btn-dc {
    background-color: #ff7c43;
    border-color: #ff7c43;
  }
}
.content {
  // max-width: 96%;
  margin: 20px;
}
.item {
  height: 40px;
  line-height: 32px;
  margin-bottom: 20px;
  font-size: 14px;
  color:#4b4b4b;
}
// /deep/ .ivu-input {
//   width: 360px;
//   color: #333;
// }
.demo-spin-container {
  display: inline-block;
  width: 200px;
  height: 100px;
  position: relative;
}

.jftitle{
    width: 70px;
    text-align: right;
    margin-right: 20px;
}
.suffix{
    margin-left: 20px;
}
.limittitle{
   margin:0 20px 0 30px;
}
.notice{
    margin-left: 30px;
    color:#999;
}

/deep/ .ivu-tag{
    background-color: #fff;
    border:1px dashed #ff7b44; 
}
/deep/ .ivu-icon-ios-close{
        background-color: #ff7b44;
        border-radius: 50%;
        color:#fff;
        transform: scale(1) !important;
        opacity: 1 !important;
    }
/deep/ .ivu-tag-text{
    color:#ff7b44;
}
</style>